import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation()

  const preferred = useMemo(() => {
    if (typeof window === 'undefined') return 'it'
    try {
      const stored = localStorage.getItem('lng')
      if (stored && (stored === 'it' || stored === 'en')) return stored
    } catch {
      // ignore
    }
    const raw = (navigator?.languages && navigator.languages[0]) || navigator?.language || 'en'
    return String(raw).toLowerCase().startsWith('it') ? 'it' : 'en'
  }, [])

  const current = i18n.language?.startsWith('it') ? 'it' : i18n.language ? 'en' : preferred

  const setLang = (lng) => {
    i18n.changeLanguage(lng)
    try { localStorage.setItem('lng', lng) } catch { /* ignore */ }
  }

  const baseBtn = 'px-3 py-1 rounded-full text-xs font-semibold tracking-[0.25em] uppercase transition'

  return (
    <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Language selector">
      <button
        type="button"
        onClick={() => setLang('it')}
        className={`${baseBtn} ${current === 'it' ? 'bg-white/90 text-slate-900' : 'bg-white/10 text-white/80 hover:bg-white/20'}`}
        aria-pressed={current === 'it'}
      >
        IT
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`${baseBtn} ${current === 'en' ? 'bg-white/90 text-slate-900' : 'bg-white/10 text-white/80 hover:bg-white/20'}`}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
    </div>
  )
}

export default LanguageToggle
